const PlaceholderAvatar = 'avatar-portraits/hom-default-avatar.png'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
const mediaQuery = [{ screen: '(min-width: 280px)', width: '150px' }]
export default function EmployeeHeadShot({
  imageSrcKey,
  imageAlt,
}: {
  imageAlt?: string | null
  imageSrcKey?: string
}): React.ReactElement {
  const imageClassName = 'p-2 inset-center object-cover rounded-full'
  return (
    <div className="relative w-40 h-40 mx-auto rounded-full bg-employee-card-outer-border" data-testid="head-shot">
      <div className="absolute inset-px rounded-full bg-gray-off-white" data-testid="head-shot-image-container">
        <ResponsiveImage
          alt={imageAlt || 'Employee Avatar'}
          fit="contain"
          height={150}
          imageClassName={imageClassName}
          imageWidths="150"
          mediaQuery={mediaQuery}
          srcKey={imageSrcKey || PlaceholderAvatar}
          width={150}
        />
      </div>
      <div className="absolute inset-0 m-2 border border-white rounded" data-testid="head-shot-image-border" />
    </div>
  )
}
